import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const WhoYouMeet = () => {
  const { t } = useLanguage();
  const w = t.whoMeet;
  if (!w) return null;

  return (
    <section className="relative py-20 md:py-24 bg-[#010E3A]" data-testid="who-you-meet">
      <div className="container-page">
        <Reveal>
          <span className="overline text-[#CEA26B]">{w.overline}</span>
          <h2 className="mt-3 font-display font-bold tracking-tight text-white text-3xl sm:text-4xl leading-tight">{w.title}</h2>
          <p className="mt-4 text-base md:text-lg text-slate-400 leading-relaxed max-w-2xl">{w.subtitle}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap gap-2">
            {[...w.featured, ...w.others]
              .sort((a, b) => a.localeCompare(b, "cs"))
              .map((name, i) => (
                <span
                  key={name}
                  data-testid={`who-other-${i}`}
                  className="inline-flex max-w-full items-center whitespace-normal break-words border border-white/15 bg-white/[0.04] px-3.5 py-1.5 text-sm text-slate-300"
                >
                  {name}
                </span>
              ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
